<form novalidate #currentForm="ngForm">
  <table class="dscp-table" mat-table [dataSource]="flowDataSource" class="table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <input
            autocomplete="off"
            type="text"
            class="input-box"
            [(ngModel)]="element.name"
            name="name{{ element.id }}"
            #nameInput="ngModel"
            (input)="nameUpdated(nameInput.name, element)"
            maxlength="30"
            required
          />
        </div>
        <div class="error" *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)">
          <mat-error *ngIf="nameInput.errors.maxlength">Name is too long</mat-error>
          <mat-error *ngIf="nameInput.errors.required">Name is required</mat-error>
        </div>
        <div *ngIf="element.nameExist">
          <mat-error>Name already exist</mat-error>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="dscp">
      <th mat-header-cell *matHeaderCellDef>DSCP</th>
      <td mat-cell *matCellDef="let element">
        <label class="label"> {{ element.id }} - {{ element.value }}</label>
      </td>
    </ng-container>
    <ng-container matColumnDef="padding">
      <th mat-header-cell *matHeaderCellDef>Padding(0-8913 B)</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div>
          <input
            autocomplete="off"
            type="number"
            class="input-box"
            [(ngModel)]="element.padding"
            name="padding{{ element.id }}"
            #paddingInput="ngModel"
            (input)="paddingUpdated(paddingInput.name, element)"
            min="0"
            max="8913"
            required
          />
        </div>
        <div
          class="error"
          *ngIf="paddingInput.invalid && (paddingInput.dirty || paddingInput.touched)"
        >
          <mat-error *ngIf="paddingInput.errors.required">Padding is required</mat-error>
          <mat-error *ngIf="paddingInput.errors.min || paddingInput.errors.max"
            >Should be 0 and 8913</mat-error
          >
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="frame-size">
      <th mat-header-cell *matHeaderCellDef>Frame Size(87-9000 B)</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div>
          <input
            autocomplete="off"
            type="number"
            class="input-box"
            [(ngModel)]="element.frameSize"
            name="frameSize{{ element.id }}"
            #frameSizeInput="ngModel"
            (input)="frameSizeUpdated(frameSizeInput.name, element)"
            [ngClass]="{
              'error-input': frameSizeInput?.errors?.required
            }"
            min="87"
            max="9000"
            required
          />
        </div>

        <div
          class="error"
          *ngIf="frameSizeInput.invalid && (frameSizeInput.dirty || frameSizeInput.touched)"
        >
          <mat-error *ngIf="frameSizeInput.errors.required">Frame Size is required</mat-error>
          <mat-error *ngIf="frameSizeInput.errors.min || frameSizeInput.errors.max"
            >Should be 87 and 9000</mat-error
          >
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="TxInterval">
      <th mat-header-cell *matHeaderCellDef>Tx Interval</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <select
          class="dropdown"
          #txInterval="ngModel"
          name="txInterval{{ i }}"
          (ngModelChange)="txIntervalUpdated(txInterval.name, element)"
          [(ngModel)]="element.txInterval"
        >
          <option *ngFor="let item of TxIntervalDropdown" [value]="item.id">
            {{ item.value }}
          </option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="dfBit">
      <th mat-header-cell *matHeaderCellDef>DF-bit</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <select
          class="option-list"
          name="dfBit{{ i }}"
          #dfBit="ngModel"
          [disabled]="dfBitDisabled"
          (ngModelChange)="dfBitValUpdate(dfBit.name, element)"
          [(ngModel)]="element.dfBit"
        >
          <option [ngValue]="false">No</option>
          <option [ngValue]="true">Yes</option>
        </select>
      </td>
    </ng-container>
    <ng-container matColumnDef="reflectorUDP">
      <th mat-header-cell *matHeaderCellDef>Reflector UDP Port</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <input
            autocomplete="off"
            type="number"
            min="1"
            max="65535"
            class="udp-input"
            [(ngModel)]="element.reflectorUDP"
            name="udp{{ element.id }}"
            #udpInput="ngModel"
            (input)="reflectorUdpUpdated(udpInput.name, element)"
            required
          />
        </div>
        <div class="error" *ngIf="udpInput.invalid && (udpInput.dirty || udpInput.touched)">
          <mat-error *ngIf="udpInput.errors.required">Reflector port is required</mat-error>
          <mat-error *ngIf="udpInput.errors.min || udpInput.errors.max"
            >Should be 1 and 65535</mat-error
          >
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="add">
      <th mat-header-cell *matHeaderCellDef>
        <div class="add-popup" (click)="openDscpFlowsDialog()">+ Add</div>
        <div class="sub-text">Maximum 10 flows allowed</div>
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <i
          class="mdi mdi-tune-vertical-variant close-circle"
          *ngIf="!(mosCodecValue === 'none' || mosCodecValue === 'generic')"
          [ngClass]="{ disableIcon: disableSetMosConfig(element) }"
          (click)="setConfigBasedOnCodec(element)"
          matTooltip="Set size and interval based on MOS Codec"
          [matTooltipPosition]="'after'"
          matTooltipClass="codec-tooltip"
        ></i>
        <i
          class="mdi mdi-close-circle-outline close-circle remove-flow-icon"
          (click)="removeDscpFlows(i)"
        ></i>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedFlowsColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedFlowsColumns"></tr>
  </table>
</form>
